import { prop } from 'ramda';
import { shallow } from 'zustand/shallow';
import { useCryptoRateSelector } from '../../store';

export const useIsCryptoRatesLoaded = () =>
  useCryptoRateSelector(() => prop('isRatesLoaded'), [], shallow);
